<template>
  <div style="background-color: white;padding: 24px">
    <a-form   :rules="validatorRules">
      <a-row :gutter="24">
        <a-col :md="20" :sm="8">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  :label="language['system.departSigne.form']">
            <a-select
              style="width: 100%"
              allowClear
              show-search option-filter-prop="children"
              :placeholder="language['common.pleaseChoose']+language['system.departSigne.form']"
              @change="formChange"
              v-model="formCode">
              <a-select-option v-for="(item,index) in formList" :key="index.toString()" :value="item.formCode">
                {{ item.formName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

       

      </a-row>
      <a-row :gutter="24">
        <a-col :md="20" :sm="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  :label="language['system.departSigne.process']">
            <a-select
              style="width: 100%"
              allowClear
              show-search option-filter-prop="children"
              :placeholder="language['common.pleaseChoose']+language['system.departSigne.process']"
              @change="modelChange"
              v-model="modelGuid">
              <a-select-option v-for="(item,index) in modelList" :key="index.toString()" :value="item.modelGuid">
                {{ item.pfBpmModel.modelNameLocalLang }}
              </a-select-option>
            </a-select>
            <a-button type="primary" @click="initTable"  icon="search">{{ language['system.departSigne.load'] }}</a-button>
          </a-form-item>
        </a-col>


<!--        <a-col :md="6" :sm="8">
          <a-button type="primary"  icon="search">{{language['common.searchButton']}}</a-button>
        </a-col>-->
      </a-row>
    </a-form>

    <a-table
      :pagination="false"
      bordered
      size="middle"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
    >
      <template slot="userNames" slot-scope="text, record, index">
        <div v-if="record.editable">
          <j-select-user :isSort="true"  :multiple="true" :sortItem="record" v-model="record.userCodes" @handleSortOk="handleSortOk" :url="signedUserURL" rowKey="workNo" />
        </div>
        <div v-else>{{text}}</div>
      </template>
      <template slot="isOrder" slot-scope="text, record, index">
<!--        <div v-if="record.editable">
          <a-radio-group v-model="record.isOrder" >
            <a-radio value="1">
              {{'是'}}
            </a-radio>
            <a-radio value="0">
              {{'否'}}
            </a-radio>
          </a-radio-group>
        </div>
        <div v-else>
            {{ text == '1'?'是':'否' }}
        </div>-->
        {{ text == '1'?language['common.yes']:language['common.no'] }}
      </template>
      <template slot="skipApproval" slot-scope="text, record, index">
        <div v-if="record.editable">
          <a-radio-group v-model="record.skipApproval" >
            <a-radio value="1">
              {{language['common.yes']}}
            </a-radio>
            <a-radio value="0">
              {{language['common.no']}}
            </a-radio>
          </a-radio-group>
        </div>
        <div v-else>
          {{ text == '1'?language['common.yes']:language['common.no'] }}
        </div>

      </template>
      <template slot="action" slot-scope="text, record, index">
        <div class="editable-row-operations">
                <span v-if="record.editable">
                  <a @click="() => save(record)">{{language['common.save']}}</a>
                  <a-divider type="vertical" />
                  <a-popconfirm :title="language['message.giveUpEditing']" @confirm="() => cancel(record)">
                    <a>{{language['common.cancel']}}</a>
                  </a-popconfirm>
                </span>
                <span v-else>
                  <a class="edit" @click="() => edit(record.id)">{{language['common.edit']}}</a>
<!--                  <a-divider type="vertical" />
                  <a class="delete" @click="() => del(record)">{{language['common.delete']}}</a>-->
                </span>
        </div>
      </template>

      <template #footer>
<!--        <a-switch v-model:checked="a==1" ></a-switch>-->
<!--        <div><a-switch v-model="true"  /></div>-->
<!--        <a-form-model>
          <a-form-model-item
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
            :label="`知会人员`">
            <j-select-user   :multiple="true" v-model="noticeUsers" :url="signedUserURL" rowKey="workNo" />
            <a-checkbox v-model="noticeShow" >设置知会</a-checkbox>
          </a-form-model-item>
        </a-form-model>-->

        <a-form   :rules="validatorRules" v-if="noticeShow">
          <a-row :gutter="24">
            <a-col :md="16" :sm="16">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  :label="language['system.departSigne.InformPersonnel']">
                <j-select-user   :multiple="true" v-model="noticeUsers" :url="signedUserURL" rowKey="workNo" :disabled="!noticeShow"/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="8" :sm="8">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol"  >
                <a-checkbox v-model="noticeShow" @change="noticeShowChange">{{ language['system.departSigne.setInform'] }}</a-checkbox>
              </a-form-item>
            </a-col>-->
          </a-row>
        </a-form>

<!--        <a-radio-group v-model="a" >
          <a-radio value="1">
            {{'是'}}
          </a-radio>
          <a-radio value="0">
            {{'否'}}
          </a-radio>
        </a-radio-group>-->
      </template>

    </a-table>
    <div style="padding-top: 10px;text-align: end;">
      <a-button type="primary" @click="submitTable('0')" style="right: 1%" v-has="'signedModel:submit'">{{ language['common.submitButton'] }}</a-button>
      <a-button type="primary" @click="coerceSubmit" v-has="'signedModel:coerceSubmit'">{{language['common.coerceSubmit']}}</a-button>
    </div>
    <div style="padding-top: 20px;">
      <span style="font-weight: 800;">{{language['common.operatingInstructions']}}：</span>
      <ul>
        <li>{{ language['departSignedModel.operatingInstructions_one'] }}</li>
        <li>{{ language['departSignedModel.operatingInstructions_two'] }}</li>
      </ul>
    </div>
<!--    <a-form   :rules="validatorRules">
      <a-row :gutter="24">
        <a-col :md="10" :sm="24">
          <a-button type="primary" @click="initTable"  icon="search">{{language['common.searchButton']}}</a-button>
        </a-col>
      </a-row>
    </a-form>-->
  </div>
</template>

<script>
import { httpAction,deleteAction,getAction } from '@/api/manage'
export default {
  name: "signedModel",
  props: {
    departId: {
      type: String,
      default:''
    },
  },
  data() {
    return{
      signedUserURL:'/sys/user/queryList?applicationCode='+this.$store.getters.applicationCode+'&applicationBy=user',
      labelCol: {
        xs: {span: 24},
        sm: {span: 5}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 16}
      },
      formList:[],
      formCode:"",

      modelList:[],
      modelGuid:"",
      validatorRules:{},

      dataRow:'',
      dataSource:[],
      noticeShow:false,
      noticeUsers:"",
      formModelVo:{},
      userCodes:null
    }
  },
  created() {
    this.initFormList()
  },
  watch:{
    departId:{
      immediate:true,
      handler(val) {
        this.initTable()
      },
    },
  },
  computed: {

    language() {
      return this.$store.getters.language
    },
    columns(){
      if(this.language){
        return [

          {
            title:this.language['system.departSigne.signeNode'],
            align:"center",
            width:80,
            dataIndex: 'taskName',
            scopedSlots: { customRender: 'taskName' }
          },
          {
            title:this.language['system.departSigne.signeNodePerson'],
            align:"center",
            width:180,
            dataIndex: 'userNames',
            scopedSlots: { customRender: 'userNames' }
            // scopedSlots: { customRender: 'langKey' }
          },
          {
            title:this.language['system.departSigne.orderSign'],
            align:"center",
            width:100,
            dataIndex: 'isOrder',
            scopedSlots: { customRender: 'isOrder' }
            // scopedSlots: { customRender: 'cnLangTrans' }
          },
          {
            title:this.language['system.departSigne.isSkip'],
            align:"center",
            width:100,
            dataIndex: 'skipApproval',
            scopedSlots: { customRender: 'skipApproval' }
            // scopedSlots: { customRender: 'cnLangTrans' }
          },
          {
            title: this.language['common.action'],
            dataIndex: 'action',
            width:100,
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ]
      }
    }

  },
  methods: {
    noticeShowChange(){
      if(!this.noticeShow){
        this.noticeUsers = "";
      }
    },
    initFormList(){
      let application = this.$store.getters.applicationCode;
      /*let applicationId = null;
      if(application.applicationType!='platform'){
        applicationId = application.id;
      }*/
      getAction("/sys/processSigned/formmodels/getFormByApplication",{"applicationCode":this.$store.getters.applicationCode}).then((res) => {//this.$store.getters.applicationCode
        if (res.success) {
          this.formList = res.result;
        }
      })
    },
    formChange(v,data){
      if(v){
        this.initModelList(v)
        /*for(var i=0;i<this.formList.length;i++){
          let item = this.formList[i];
          if(item.formCode == v){
            this.formNoticeShow = item.showNotice
          }
        }*/
      }else{
        this.modelList = [];
        this.modelGuid = '';
        this.formNoticeShow = false;
      }

    },
    initModelList(formCode){
      if(!formCode){
        return
      }
      this.modelGuid = '';
      getAction("/sys/processSigned/formmodels/alllist",{"formCode":formCode}).then((res) => {//this.$store.getters.applicationCode
        if (res.success) {
          this.modelList = res.result;
        }
      })
    },
    modelChange(v,data){
      if(v){
        this.modelGuid = v;
        // this.initTable(v)
      }else{
        this.modelGuid = "";
      }
    },
    initTable(){
      if(this.modelGuid&&this.departId){
        this.dataSource = [];
        this.noticeShow = false;
        getAction("/sys/processSigned/pfBpmModelTask/listByModelGuidWithDepart",{"modelGuid":this.modelGuid,"departId":this.departId}).then((res) => {//this.$store.getters.applicationCode
          if (res.success) {
            this.dataSource = res.result;
            this.dataRow = '';
          }
        })
        getAction("/sys/processSigned/formmodels/getFormAndNoticeApproverByApplication",{"modelGuid":this.modelGuid,"departId":this.departId}).then((res) => {//this.$store.getters.applicationCode
          if (res.success) {
            if(res.result){
              this.noticeShow = res.result.showNoticeFlag==1?true:false
              this.noticeUsers = res.result.pfBpmDepartModelNotice?res.result.pfBpmDepartModelNotice.noticeUsers:"";
              this.formModelVo = res.result;
            }
            /*this.dataSource = res.result;
            this.dataRow = '';*/
          }
        })
      }
    },
    coerceSubmit(){
      if(this.dataSource && this.dataSource.length>0) {
        if (this.dataRow != '') {
          this.$message.error(this.language['system.departSigne.errorPendingEdits']);
          return;
        }
        for (var i = 0; i < this.dataSource.length; i++) {
          var item = this.dataSource[i];
          let boo = this.validatorRow(item);
          if (!boo) {
            this.$message.error(item.taskName + this.language['system.departSigne.errorPleaseSetChecker']);
            return
          }
        }
        if (this.noticeShow && this.noticeUsers == "") {
          this.$message.error(this.language['system.departSigne.errorNotSetInformPersonnel']);
          return;
        }
        this.$confirm({
          title: this.language['common.operatingInstructions'],
          content: this.language['departSignedModel.operatingInstructionsWarning'],
          centered: true,
          onOk: () => {
            // this.submitTable("1")
            httpAction("/sys/processSigned/taskapproverssetting/saveDepartSigned/1", this.dataSource,'post').then((res) => {
              if (res.success) {
                if(this.formModelVo) {
                  let formModel = this.formModelVo
                  formModel.showNoticeFlag = this.noticeShow ? "1" : "0";
                  if(formModel.pfBpmDepartModelNotice){
                    formModel.pfBpmDepartModelNotice.noticeUsers = this.noticeUsers
                    formModel.pfBpmDepartModelNotice.departId = this.departId
                    formModel.pfBpmDepartModelNotice.modelGuid = formModel.modelGuid
                  }else{
                    let notice = {};
                    notice.noticeUsers = this.noticeUsers
                    notice.departId = this.departId
                    notice.modelGuid = formModel.modelGuid
                    formModel.pfBpmDepartModelNotice = notice
                  }
                  httpAction("/sys/processSigned/departmodelnoticesetting/savePfbpmdepartmodelnotices", formModel, 'post').then((res) => {
                    if (res.success) {
                      this.$message.success(res.message);
                      this.initTable();
                    } else {
                      this.$message.warning(res.message);
                    }
                  });
                }
              } else {
                this.$message.warning(res.message);
              }
            });

          }
        })
      }

    },
    submitTable(isCoerce){
      if(this.dataSource && this.dataSource.length>0){
        if(this.dataRow!=''){
          this.$message.error(this.language['system.departSigne.errorPendingEdits']);
          return;
        }
        for(var i=0;i<this.dataSource.length;i++){
          var item = this.dataSource[i];
          let boo = this.validatorRow(item);
          if(!boo){
            this.$message.error(item.taskName+this.language['system.departSigne.errorPleaseSetChecker']);
            return
          }
        }
        if(this.noticeShow&&this.noticeUsers==""){
          this.$message.error(this.language['system.departSigne.errorNotSetInformPersonnel']);
          return;
        }
        httpAction("/sys/processSigned/taskapproverssetting/saveDepartSigned/"+isCoerce, this.dataSource,'post').then((res) => {
          if (res.success) {
            if(this.formModelVo) {
              let formModel = this.formModelVo
              formModel.showNoticeFlag = this.noticeShow ? "1" : "0";
              if(formModel.pfBpmDepartModelNotice){
                formModel.pfBpmDepartModelNotice.noticeUsers = this.noticeUsers
                formModel.pfBpmDepartModelNotice.departId = this.departId
                formModel.pfBpmDepartModelNotice.modelGuid = formModel.modelGuid
              }else{
                let notice = {};
                notice.noticeUsers = this.noticeUsers
                notice.departId = this.departId
                notice.modelGuid = formModel.modelGuid
                formModel.pfBpmDepartModelNotice = notice
              }
              httpAction("/sys/processSigned/departmodelnoticesetting/savePfbpmdepartmodelnotices", formModel, 'post').then((res) => {
                if (res.success) {
                  this.$message.success(res.message);
                  this.initTable();
                } else {
                  this.$message.warning(res.message);
                }
              });
            }
          } else {
            this.$message.warning(res.message);
          }
        });
      }
    },
    validatorRow(row){
      if(row.skipApproval == 0 && !row.userCodes){
        return false;
      }else{
        return true;
      }
    },




    /*  表格 */
    handleChange (value, key, column) {
      const newData = [...this.dataSource];
      const target = newData.filter(item => key === item.key)[0];
      if (target) {
        target[column] = value;
        this.dataSource = newData;
      }
    },
    edit (id) {
      if(this.dataRow!=''){
        return;
      }
      const newData = [...this.dataSource];
      const target = newData.filter(item => id === item.id)[0];
      this.dataRow = {...target};
      // 根据rowKey判断该行数据是否存在
      if (target) {
        target.editable = true;   // 修改target可以直接影响到newData
        this.dataSource = newData;
      }
    },
    save (row) {
      const newData = [...this.dataSource];
      const target = newData.filter(item => row.id === item.id)[0];
      if (target) {
        // 将缓存数据中匹配到的数据对象覆盖合并当前被修改的行
        // target.editable = false;
        if(target.userCodes){
          getAction("/sys/user/getUserByWorkNos",{allWorkNo:target.userCodes}).then((res)=>{
            if(res.success){
              target.userNames = res.result;
            }
          })
        }else {
          target.userNames = "";
        }
        delete target.editable;
        this.dataSource = newData;
        this.dataRow = '';
      }
      /*httpAction("/sys/processSigned/taskapproverssetting/saveDepartSigned", row,'post').then((res) => {
        if (res.success) {
          this.$message.success(res.message);
          this.initTable();
        } else {
          this.$message.warning(res.message);
        }
      });*/

    },
    cancel (row) {
      console.log(row);
      const newData = [...this.dataSource];
      const target = newData.filter(item => row.id === item.id)[0];
      if (target) {
          // 将缓存数据中匹配到的数据对象覆盖合并当前被修改的行
          // target.editable = false;
          Object.assign(target, this.dataRow);
          delete target.editable;
          this.dataSource = newData;
          this.dataRow = '';
      }
    },

    handleSortOk(id, userCodes, userNames) {
      console.log('id =', id, 'userCodes = ', userCodes)
      this.dataSource.forEach(item => {
        if (item.id == id) {
          this.$set(item, 'userCodes', userCodes)
          this.$set(item, 'userNames', userNames)
        }
      });
    },  

  }
}
</script>

<style scoped>

</style>